import React, { useState, useEffect, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import Floorplan from "../Floorplan/Floorplan";
import "./FloorplanPopup.scss";
import {
    updateActiveElevation,
    updateActiveFloor,
    updateActiveFloorplan,
} from "../../redux/actions/floorplanActions";

function FloorplanPopup(props) {
    const dispatch = useDispatch();
    var activeFloorplanID = useSelector(
        (state) => state.floorplan.activeFloorplanID
    );
    var activeElevationID = useSelector(
        (state) => state.floorplan.activeElevationID
    );

    var dotClasses = "dot";
    var innerDotClasses = "inner-dot-popup";

    const [isElementActive, setElementActive] = useState(false);

    function dotClickFunction() {
        setElementActive((oldState) => !oldState);
    }

    if (isElementActive) {
        dotClasses += " active";
        innerDotClasses += " active";
    }

    var thePopUpDots = props.plan?.popup_dots || [];

    return (
        <React.Fragment>
            {thePopUpDots.map((dot, dotkey) => {
                var content = dot.popup_content;
                var topNum = dot.top;
                var leftNum = dot.left;
                var dotLocation = {
                    top: topNum,
                    left: leftNum,
                };
                return (
                    <div
                        key={dotkey}
                        className="dot-floorplan"
                        style={dotLocation}
                    >
                        <div className="dot-wrapper">
                            <div
                                className={dotClasses}
                                onClick={dotClickFunction}
                            ></div>
                            <div className={innerDotClasses}>
                                <div className="floorplan-info-popup">
                                    <p className="inner-content">{content}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </React.Fragment>
    );
}

export default FloorplanPopup;
